import styled from "styled-components";
import { Blank, IconButton } from "@evergis/ui";

export const ProxyLayersList = styled.div`
  margin-top: 1.5rem;
`;

export const ProxyLayerContainer = styled(Blank)`
  display: flex;
  padding: 0.75rem 1.5rem 0.75rem 1.5rem;
  align-items: center;

  &:not(:last-of-type) {
    margin-bottom: 0.5rem;
  }

  > div:not(:last-of-type) {
    margin-right: 0.875rem;
  }
`;

export const DeleteButton = styled(IconButton)`
  margin-left: 0.5rem;
  margin-bottom: -1rem;
`;

export const SmallMessageText = styled.div`
  font: ${({ theme: { fonts } }) => fonts.small};
  color: rgba(0, 0, 0, 0.65);
  margin-top: 0.5rem;
`;
